<template>
  <div class="vendedores-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Vendedores">
          <b-table hover
              responsive="sm" 
              class="registro"
              :items="vendedores" 
              :fields="itemFields"
              :busy="tableBusy"
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Vendedor</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'vendedores/getField',
  mutationType: 'vendedores/updateField',
});

export default {
  name: 'VendedoresList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      itemFields: [
        {
          key: 'codigo',
          sortable: true
        },
        {
          key: 'nombre',
          sortable: true
        },
        { key: 'celular' },
        { key: 'email' },
        {
          key: 'opciones',
          label: '',
          class: "text-center"
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'vendedores',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'incluirInactivos',
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('vendedores/getVendedores')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'VendedorData', 
                          params: { id: item.id }})
    },
    editar (item) {
      this.$router.push({ name: 'VendedorEdit', 
                          params: { id: item.id }})
    },
    agregar () {
      this.$router.push({ name: 'VendedorAdd' })
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
  .vendedores-list .registro table td[aria-colindex="1"] {
    width: 30%;
  }
  .vendedores-list .registro table td[aria-colindex="2"] {
    width: calc(45% - 60px);
  }
  .vendedores-list .registro table td[aria-colindex="3"] {
    width: 10%;
  }
  .vendedores-list .registro table td[aria-colindex="4"] {
    width: 15%;
  }
  .vendedores-list .registro table td[aria-colindex="5"] {
    width: 60px;
  }

</style>
